import { useCandidateAuth } from 'features/auth/AuthProvider';
import { useCallback, useEffect, useState } from 'react';
import { redirectToOldPortal } from 'shared/utils/browserCompat';

import { ApiError, fetchTenant, fetchTenantByOldAvailabilityToken } from '../api';
import { tenantContextInitialValue, TenantContextShape } from '../contexts';

export default function useFetchTenant() {
    const [ state, setState ] = useState<TenantContextShape>(tenantContextInitialValue);
    const { accessToken, status: authStatus } = useCandidateAuth();

    const { tenant, error, status: tenantLoadingStatus } = state;

    const loadTenant = useCallback(async () => {
        setState((prevState) => ({
            ...prevState,
            status: 'pending'
        }));

        const response = accessToken.oldAvailabilityToken
            ? await fetchTenantByOldAvailabilityToken(accessToken.oldAvailabilityToken)
            : await fetchTenant();

        if (response instanceof ApiError) {
            setState({
                tenant: null,
                error: response,
                status: 'error'
            });

            return;
        }

        const candidateRoleIsEnabled = response.featuresEnabled?.CandidateRole ?? false;

        if (!candidateRoleIsEnabled) {
            redirectToOldPortal('feature-disabled');

            return;
        }

        setState({ tenant: {
            ...response,
            clarityEnabled: true
        }, status: 'success' });
    }, [ accessToken ]);

    useEffect(() => {
        if (tenantLoadingStatus === 'idle' && (authStatus !== 'idle' || accessToken.token && !accessToken.fullAccess)) {
            loadTenant();
        }
    }, [ loadTenant, tenantLoadingStatus, authStatus, accessToken.token, accessToken.fullAccess ]);

    return { tenant, error, status: tenantLoadingStatus };
}
